import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { AdminTable } from "./AdminTable";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { Check } from "lucide-react";

export default function AdminEnquiries() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/enquiries").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const markHandled = async (r) => {
    await api.patch(`/admin/enquiries/${r.id}`, { handled: !r.handled });
    load();
  };

  const del = async (r) => {
    if (!window.confirm("Delete this enquiry?")) return;
    await api.delete(`/admin/enquiries/${r.id}`);
    toast.success("Deleted"); load();
  };

  return (
    <div data-testid="admin-enquiries">
      <h1 className="font-serif text-4xl">Enquiries</h1>
      <p className="text-foreground/60 mb-6 mt-1">Contact form submissions.</p>

      <AdminTable
        testIdPrefix="e-row"
        columns={[
          { key: "name", label: "Name" },
          { key: "email", label: "Email" },
          { key: "subject", label: "Subject" },
          { key: "message", label: "Message", render: (r) => <div className="max-w-md truncate text-foreground/70 text-xs">{r.message}</div> },
          { key: "handled", label: "Status", render: (r) => (
            <Button size="sm" variant={r.handled ? "outline" : "default"} onClick={() => markHandled(r)}
              className={`rounded-full text-xs ${r.handled ? "" : "bg-[#D4AF37] hover:bg-[#AD974F] text-[#0B1F3A]"}`}>
              {r.handled ? "Handled" : <><Check className="w-3 h-3 mr-1" />Mark handled</>}
            </Button>
          ) },
        ]}
        rows={rows}
        onDelete={del}
      />
    </div>
  );
}
